import * as Yup from "yup";

export const circleLeaderApplicationValidation = Yup.object().shape({
  userId: Yup.string().required("Required"),
  email: Yup.string().email("Invalid email").required("Required"),
  reason: Yup.string()
    .min(3, "code length too short")
    .required("Please you must provide a reason."),
  hasAgreedToTerms: Yup.bool().required("You must agree to terms & conditions"),
});

export const accountVerificationValidation = Yup.object().shape({
  userId: Yup.string().required("User ID is required"),

  dateOfBirth: Yup.date()
    .required("Date of Birth is required")
    .max(new Date(), "Date of Birth cannot be in the future"),

  lawfulIdNumber: Yup.string().required("Valid ID Number is required"),

  socialSecurityNumber: Yup.string()
    .optional()
    .matches(
      /^\d{3}-\d{2}-\d{4}$/,
      "Social Security Number must be in the format XXX-XX-XXXX"
    )
    .nullable(),

  phone: Yup.object().shape({
    countryCode: Yup.string().optional().max(3).min(1).nullable(),
    number: Yup.string().required("Phone number is required"),
  }),

  address: Yup.object().shape({
    streetName: Yup.string().required("Street name is required"),
    zipCode: Yup.string().required("Zip code is required"),
    city: Yup.string().required("City is required"),
    state: Yup.string().required("State is required"),
    country: Yup.string().required("Country is required"),
    county: Yup.string().optional(),
  }),

  sourceOfIncome: Yup.object().shape({
    sourceType: Yup.string().when("isEmployed", (isEmployed, schema) =>
      isEmployed ? schema.optional().nullable() : schema.optional().nullable()
    ),
    incomeAmount: Yup.string().when("isEmployed", (isEmployed, schema) =>
      isEmployed ? schema.optional().nullable() : schema.optional().nullable()
    ),
  }),

  employer: Yup.object().shape({
    employerName: Yup.string().optional().nullable(),
    yearsWithEmployer: Yup.number().optional().nullable(),
    income: Yup.number().optional().nullable(),
    employerAddress: Yup.object().shape({
      streetName: Yup.string().optional().nullable(),
      zipCode: Yup.string().optional().nullable(),
      city: Yup.string().optional().nullable(),
      state: Yup.string().optional().nullable(),
      country: Yup.string().optional().nullable(),
      county: Yup.string().optional().nullable(),
    }),
  }),

  relatives: Yup.object().shape({
    fullName: Yup.string().optional().nullable(),

    phone: Yup.object().shape({
      countryCode: Yup.string().optional().nullable(),
      number: Yup.string().optional().nullable(),
    }),

    address: Yup.object().shape({
      streetName: Yup.string().optional().nullable(),
      zipCode: Yup.string().optional().nullable(),
      city: Yup.string().optional().nullable(),
      state: Yup.string().optional().nullable(),
      country: Yup.string().optional().nullable(),
      county: Yup.string().optional().nullable(),
    }),
  }),
});
